import OtpInput from 'react-otp-input';

export default function Input(props) {
  const { input: { onChange }, disabled, onChangeHook, wrapperClasses, label, meta: { touched, error, warning } } = props
  return (
    <div className={`${disabled && 'disabled'} ${wrapperClasses}`}>
      {label !== undefined && <label>{props.label}</label>}
      <OtpInput
        value={props.input.value}
        otpType='number'
        onChange={otp => {
          onChange(otp);
          if (onChangeHook) {
            onChangeHook(otp);
          }
        }}
        autoFocus
        numInputs={6}
        separator={<span>-</span>}
      />
      {touched &&
        ((error && <span className="invalid-feedback text-danger d-inline la-sm">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  )
}
